module.exports = __webpack_public_path__ + "images/pro/payment-goalipay@2x-62e2ed46a68fcf1d6916878cab7e0d19.png";